module.exports = __webpack_public_path__ + "img/123.5d053f2.svg";